import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetInventoryInvoicesResponse,
    GetWorkplaceItemsParams,
    GetWorkplaceItemsResponse,
} from '@/new-services/types/reports'

type ApiGetWorkplaceItemsResponse = Promise<AxiosResponse<GetWorkplaceItemsResponse>>
type ApiGetInventoryInvoicesResponse = Promise<AxiosResponse<GetInventoryInvoicesResponse>>

export function getWorkplaceItems(params: GetWorkplaceItemsParams): ApiGetWorkplaceItemsResponse {
    return http.get('/reports/api/workplace', { params })
}

export function getInventoryInvoices(): ApiGetInventoryInvoicesResponse {
    return http.get('/tms/api/workplace/inventory-invoices')
}

export default {
    getWorkplaceItems,
    getInventoryInvoices,
}
